export const FEATURE_SOURCE_ALL = 'all';

export const APP_VIEW_INTRO = 'intro';
export const APP_VIEW_LIST = 'list';
export const APP_VIEW_DETAILS = 'details';

export const ROUTE_BASENAME = '/apps/kulturnacht2025';

// Ordered list: first will take precedence
export const ROUTES = {
	DETAILS: {
		path: '/details/:featureId',
		props: {view: APP_VIEW_DETAILS},
	},
	LIST: {
		path: '/all',
		props: {view: APP_VIEW_LIST},
	},
	INTRO: {
		path: '/',
		props: {view: APP_VIEW_INTRO},
	},
};

export const EVENT_DATE = new Date(2025, 5, 14); // (2023, 5, 22) === 22.06.2023

export const getTimestampForTimeAtEventDate = (
	hours,
	minutes = 0,
	seconds = 0
) => {
	const date = new Date(EVENT_DATE);
	date.setHours(hours);
	date.setMinutes(minutes);
	date.setSeconds(seconds);

	return +date / 1000;
};

const oneDay = 86400;
const TIME_18 = getTimestampForTimeAtEventDate(18);
const TIME_19 = getTimestampForTimeAtEventDate(19);
const TIME_20 = getTimestampForTimeAtEventDate(20);
const TIME_21 = getTimestampForTimeAtEventDate(21);
const TIME_22 = getTimestampForTimeAtEventDate(22);
const TIME_23 = getTimestampForTimeAtEventDate(23);
const TIME_END = getTimestampForTimeAtEventDate(0) + oneDay;

export const TIME_SLOTS = [
	{label: '<', to: TIME_18 - 1},
	{label: '18', from: TIME_18, to: TIME_19 - 1},
	{label: '19', from: TIME_19, to: TIME_20 - 1},
	{label: '20', from: TIME_20, to: TIME_21 - 1},
	{label: '21', from: TIME_21, to: TIME_22 - 1},
	{label: '22', from: TIME_22, to: TIME_23 - 1},
	{label: '23', from: TIME_23},
	{label: '>', from: TIME_END},
];
